// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2349":"css/admin-app.7075","7114":"css/app.7075"}[chunkId] + ".css";
};